/*global cordova*/

var SPINTOUCH_SERVICE_UUID           = "00000000-0000-1000-8000-bbbd00000000" ;
var SPINTOUCH_SERVICE_TTEST_UUID     = "00000000-0000-1000-8000-bbbd00000010" ;
var SPINTOUCH_SERVICE_TESTAVAIL_UUID = "00000000-0000-1000-8000-bbbd00000011" ;
//var SPINTOUCH_SERVICE_SENDTEST_UUID  = "00000000-0000-1000-8000-bbbd00000012" ;
var SPINTOUCH_SERVICE_TESTACK_UUID   = "00000000-0000-1000-8000-bbbd00000013" ;

var SPINTOUCH_TEST_TYPES = {
    1  :"freeCl"    ,
    2  :"totalCl"   ,
    3  :"bromine"   ,
    6  :"ph"        ,
    7  :"alk"       ,
    10 :"stab"      ,
    11 :"fe"        ,
    12 :"cu"        ,
    14 :"phosphate" ,
    15 :"hardness"  ,
    16 :"salt"      ,
    18  :"ph"       , //3 way 501 disk has separate zone for each usage
    19  :"ph"       ,
    20  :"ph"       ,
    27  :"freeCl"   , 
    28  :"freeCl"   ,
    29  :"freeCl"   ,
    30  :"bromine"  ,
    31  :"bromine"  ,
    32  :"bromine"  ,
    33  :"totalCl"  ,
    34  :"totalCl"  ,
    35  :"totalCl"  ,
    42  :"alk"      ,
    43  :"alk"      ,
    44  :"alk"      ,
} ;

// ASCII only
function bytesToString(buffer) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
}

//iOS test for data parse?
//https://github.com/don/cordova-plugin-ble-central/blob/master/examples/rfduinoLedButton/www/js/index.js


if (typeof Float32Array !== 'undefined') {
    //iOS polyfill
    if (!Float32Array.prototype.values) Float32Array.prototype.values = Array.prototype.values;
}

function checkLocation(callback){
    if(window.device.platform === "iOS"){
        return callback() ;
    }

    cordova.plugins.locationAccuracy.request(function(){
        callback() ;
    }, function (error){
        console.error("Accuracy request failed: error code="+error.code+"; error message="+error.message);
        callback("MISSING_LOCATION_PERMISSION") ;
    }, cordova.plugins.locationAccuracy.REQUEST_PRIORITY_BALANCED_POWER_ACCURACY);
}

module.exports.getSpinlabBLEResults = function (callback) {
    checkLocation(function(err){
        if(err){ return callback(err) ;}
        window.ble.isEnabled(
            function() {
                console.log("Bluetooth is enabled");
                connectAndGetResult(callback) ;
            },
            function() {
                console.log("Bluetooth is *not* enabled, try to enable it");
                if(window.device.platform === "iOS"){
                    //on iOS we can't turn bluetooth on automatically
                    return callback("BT_NOT_ACTIVE") ;
                }
                window.ble.enable(
                    function() {
                        console.log("Bluetooth is enabled");
                        connectAndGetResult(callback) ;
                    },
                    function() {
                        console.log("The user did *not* enable Bluetooth");
                        callback("BT_NOT_ACTIVE") ;
                    }
                );
            }
        );
    }) ;
} ;

function connectAndGetResult (callback) {

    var foundDevice = null;
    var error = null;
    setTimeout(function(){
        if(!error && !foundDevice){
            callback("NOT_FOUND") ;
        }
    }, 6000) ;
    window.ble.scan([], 5, function(device){
        console.log(JSON.stringify(device));
        if(device.name && device.name.indexOf("SpinTouch") === 0){
            foundDevice = device ;
            window.ble.connect(device.id, function(peripheral){
                console.log("peripheral.characteristics", peripheral.characteristics) ;
                var callbackOkDone = false;
                window.ble.startNotification(device.id, SPINTOUCH_SERVICE_UUID, SPINTOUCH_SERVICE_TESTAVAIL_UUID, function(data){
                    window.ble.read(device.id, SPINTOUCH_SERVICE_UUID, SPINTOUCH_SERVICE_TTEST_UUID, function(data){
                        console.log("data", data) ;

                        var spinResult = {} ;

                        var view1 = new DataView(data);
                        var offset = 4;
                        for(var i=0; i<12; i++){
                            var testCode = view1.getInt8(offset) ;

                            var resultCode = SPINTOUCH_TEST_TYPES[testCode] ;
                            //console.log("TestCode",testCode) ;
                            var floatData = new Float32Array(data.slice(offset+2,offset+6)) ;
                            // console.log("float data ?", floatData);
                            // console.log("float data 0 ?", floatData[0]);
                            var floatValue =  0;
                            if(floatData.values){
                                floatValue =  floatData.values().next().value ;
                            }else{
                                floatValue =  floatData[0] ;
                            }
                            // console.log("float data val ",floatValue) ;
                            if(resultCode){
                                if(resultCode === "phosphate" || resultCode === "salt"){
                                    floatValue = (floatValue||0)/1000 ;
                                }else if(resultCode === "alk"){
                                    floatValue = Math.round(floatValue||0) ;
                                }
                                spinResult[resultCode] = floatValue ;
                            }

                            offset += 6 ;
                        }
                        var ack = new Uint8Array(1);
                        ack[0] = 1;
                        console.log("ack", ack);
                        
                        window.ble.write(device.id, SPINTOUCH_SERVICE_UUID, SPINTOUCH_SERVICE_TESTACK_UUID, ack.buffer, function(){
                            console.log("ack sent");
                            callbackOkDone = true;
                            window.ble.disconnect(device.id,function(){
                                console.log("disconnect done");
                                callback(null, spinResult) ; //<-- this is repeated below for "OK error"
                            },function(err){ 
                                if(!callbackOkDone){
                                    err.step = "DISCONNECT";
                                    callback(err) ;
                                }
                            });
                        },function(err){ 
                            console.log("error", err);
                            if(err === "OK"){
                                //this is not an error !
                                window.ble.disconnect(device.id,function(){
                                    callbackOkDone = true;
                                    callback(null, spinResult) ;//<-- this is repeated above for normal case
                                },function(err){ 
                                    if(!callbackOkDone){
                                        err.step = "DISCONNECT2";
                                        callback(err) ;
                                    }
                                });
                            }else{
                                console.log("ACK ERR", err); 
                                err.step = "ACK";
                                callback(err) ;
                            }
                        });
                    }, function(err){ 
                        console.log("READ ERR", err); 
                        if(!callbackOkDone){
                            err.step = "READ2";
                            callback(err) ;
                        }
                    });
                }, function(err){ console.log("NOTIF ERR", err); 
                    if(!callbackOkDone){
                        err.step = "NOTIF";
                        callback(err) ;
                    }
                });
            }, function(err){ console.log("CONNECT ERR", err); err.step = "CONNECT";  callback(err) ;});
        }
    }, function(err){
        error = err;
        console.log("scan error", err);
        callback(err) ;
    });
} ;
// module.exports.getSpinlabBLEResults = function (callback) {
//     navigator.bluetooth.requestDevice({
//         //acceptAllDevices: true,
//         optionalServices: ['00000000-0000-1000-8000-BBBD00000000'.toLowerCase()],
//         filters: [{namePrefix: "SpinTouch"}]
//         // filters: [{ services: ['00000000-0000-1000-8000-BBBD00000000'.toLowerCase()] }] 

//     })
//         .then(device => {

//             // Human-readable name of the device.
//             console.log(device.name);

//             return device.gatt.connect();

//             // Attempts to connect to remote GATT Server.
//             //return device.gatt.connect();
//         })
//         .then(server => {
//             console.log("gatt connected, connect to service");
//             return server.getPrimaryService('00000000-0000-1000-8000-BBBD00000000'.toLowerCase());
//         })
//         .then(service => {
//             console.log("service connected, get characteristics");
//             return service.getCharacteristics();
//         })
//         // .then(service => {
//         //     return service.getCharacteristic('00000000-0000-1000-8000-BBBD00000010'.toLowerCase());
//         // })
//         // .then(characteristic => {
//         //     //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
//         //     return characteristic.readValue();
//         // })
//         .then(characteristics => {
//             //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DataView
//             console.log("characteristics", characteristics) ;
//         })
//         .then(value => {
//             console.log('Test value ', value);
//             window.alert('Test value ' + value);
//         })
//         .catch(error => { console.log(error); });
// };